import styled from '@emotion/styled'

const FiltersContainer = styled.div`
  display: flex;
  margin-bottom: 12px;
  min-height: 38px;
`

export default FiltersContainer
